import { ReactElement, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { EntityIdAndPaginationParams } from '../../../../../../shared/models/entity-id-and-pagination-params.model';
import { useAppDispatch } from '../../../../../../store/hooks';
import Modal from '../../../../../shared/components/modal/Modal';
import { ModalContext } from '../../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { ReleaseModel } from '../../../../models/release.model';
import { releasesActions } from '../../../../store/slices/releases.slice';
import { deleteAppRelease } from '../../../../thunks/delete-app-release.thunk';
import { getAppReleases } from '../../../../thunks/get-app-releases.thunk';

export const useGetModalAndReleases = (
  ids: number[],
  appId?: string
): ReactElement => {
  const ctx = useContext(ModalContext) as ModalContextModel;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const deleteModal = useDeleteModal<
    ReleaseModel,
    number,
    ReleaseModel[],
    Partial<EntityIdAndPaginationParams>
  >({
    ids: ids,
    deleteAction: deleteAppRelease,
    param: { entityId: parseInt(appId as string, 10) },
    afterDeleteAction: getAppReleases,
  });

  useEffect(() => {
    if (ids.length && !ctx.isOpen) {
      ctx.componentHandler(deleteModal);
      ctx.modalStateHandler();
    }
  }, [ids]);

  useEffect(() => {
    return () => {
      dispatch(releasesActions.resetReleasesSliceState());
    };
  }, []);

  useEffect(() => {
    dispatch(getAppReleases({ entityId: parseInt(appId as string, 10) }))
      .unwrap()
      .catch(err => {
        console.warn(err);
        // TODO: Confirm if use should be redirected to all apps or that a 404 Not Found page should be shown
        navigate('/appstore/all-apps');
      });
  }, []);

  return <Modal>{ctx.component}</Modal>;
};
